import React, { useEffect, useState } from 'react';
import { getGitHubAppStatus, getGitHubAppInstallUrl } from '../services/api';
import './GitHubIntegrations.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const GitHubIntegrations = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getGitHubAppStatus()
      .then((res) => setStatus(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleInstall = async () => {
    try {
      const res = await getGitHubAppInstallUrl();
      const url = res.data.installUrl || res.data.url;
      if (url) window.open(url, '_blank');
    } catch (err) {
      console.error('Failed to get install URL:', err);
    }
  };

  if (loading) return <div className="github-integrations"><div className="spinner" /></div>;

  return (
    <div className="github-integrations">
      <h1>GitHub Integrations</h1>
      <p className="page-desc">GitHub App and webhook configuration for org-wide access and real-time sync</p>

      <section className="card integration-card">
        <h2>GitHub App</h2>
        <div className={`status-pill ${status?.configured ? 'configured' : 'not-configured'}`}>
          {status?.configured ? 'Configured' : 'Not configured'}
        </div>
        <p className="hint">
          Install the GitHub App to grant org-wide repository access without relying on individual OAuth tokens.
          Set <code>GITHUB_APP_ID</code>, <code>GITHUB_APP_PRIVATE_KEY</code>, and <code>GITHUB_APP_SLUG</code> in backend env.
        </p>
        {status?.configured && (
          <button className="btn btn-primary" onClick={handleInstall}>Install / manage GitHub App</button>
        )}
        {status?.installations?.length > 0 && (
          <ul className="installation-list">
            {status.installations.map((inst) => (
              <li key={inst.installationId}>
                <strong>{inst.accountLogin}</strong> ({inst.accountType}) — ID {inst.installationId}
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="card integration-card">
        <h2>Webhooks</h2>
        <p>Point your GitHub App or org webhook to:</p>
        <code className="webhook-url">{status?.webhookUrl || `${API_URL.replace('/api', '')}/api/webhooks/github`}</code>
        <p className="hint">
          Set <code>GITHUB_WEBHOOK_SECRET</code> and subscribe to: <strong>member</strong>, <strong>repository</strong>,
          <strong> installation</strong>, <strong>installation_repositories</strong>, <strong>organization</strong>.
        </p>
        <h3>Events handled</h3>
        <ul className="event-list">
          <li><strong>member</strong> — collaborator added/removed/edited → sync permissions</li>
          <li><strong>repository</strong> — created/updated/deleted → sync DB</li>
          <li><strong>installation</strong> — app installed/uninstalled</li>
          <li><strong>installation_repositories</strong> — repos added/removed from app</li>
          <li><strong>organization</strong> — org membership changes (logged)</li>
        </ul>
      </section>

      <section className="card integration-card">
        <h2>API documentation</h2>
        <p>Interactive OpenAPI docs are available at:</p>
        <a href={`${API_URL.replace('/api', '')}/api/docs`} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
          Open Swagger UI
        </a>
      </section>
    </div>
  );
};

export default GitHubIntegrations;
